<template>
    <v-container fluid class="pa-0">
        <v-overlay :value="isLoading" style="z-index: 1002">
            <v-progress-circular :size="70" :width="7" indeterminate></v-progress-circular>
        </v-overlay>
        <!-- ============================================= -->
        <h1 class="ma-5">画像解析集計</h1>
        <v-row class="ma-1">
            <v-col cols="12">
                <v-menu ref="monthMenu" v-model="menuMonth" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="targetMonth" label="集計月" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="targetMonth" type="month" no-title scrollable locale="jp" @change="changeMonth()" :max="maxMonth"></v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="12">
                <v-card v-for="dev in dbDevices" :key="dev.id" color="blue darken-3" class="mb-5">
                    <v-card-title>
                        <h4 class="white--text">{{ dev.name }}</h4>
                    </v-card-title>
                    <v-card-text class="pa-0">
                        <v-data-table hide-default-footer :headers="tblHeader" :items="dev.sparklines" mobile-breakpoint="0" multi-sort dense :items-per-page="-1">
                            <template v-slot:[`item.date`]="{ item }">
                                <v-btn class="pa-0" color="primary" small text :to="{ name: 'Playback', params: { device_id: dev.id, target_date: item.date } }">{{ item.date }}</v-btn>
                            </template>
                            <template v-slot:[`item.shot`]="{ item }">
                                <v-progress-linear class="ma-2" height="15" :value="item['shot']" color="pink lighten-4">
                                    <h4>{{ item["shot"] }}</h4>
                                </v-progress-linear>
                            </template>
                            <template v-slot:[`item.deer`]="{ item }">
                                <v-progress-linear class="ma-2" height="15" :value="(item['deer'] / 10) * 100" color="amber lighten-2">
                                    <h4>{{ item["deer"] }}</h4>
                                </v-progress-linear>
                            </template>
                            <template v-slot:[`item.boar`]="{ item }">
                                <v-progress-linear class="ma-2" height="15" :value="(item['boar'] / 10) * 100" color="brown lighten-3">
                                    <h4>{{ item["boar"] }}</h4>
                                </v-progress-linear>
                            </template>
                            <template v-slot:[`item.boarlet`]="{ item }">
                                <v-progress-linear class="ma-2" height="15" :value="(item['boarlet'] / 10) * 100" color="purple lighten-3">
                                    <h4>{{ item["boarlet"] }}</h4>
                                </v-progress-linear>
                            </template>
                            <template v-slot:[`item.monkey`]="{ item }">
                                <v-progress-linear class="ma-2" height="15" :value="(item['monkey'] / 10) * 100" color="lime darken-3">
                                    <h4>{{ item["monkey"] }}</h4>
                                </v-progress-linear>
                            </template>
                            <template v-slot:[`item.bear`]="{ item }">
                                <v-progress-linear class="ma-2" height="15" :value="(item['bear'] / 10) * 100" color="red lighten-1">
                                    <h4>{{ item["bear"] }}</h4>
                                </v-progress-linear>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
                <!--
                <v-expansion-panels multiple>
                    <v-expansion-panel v-for="dev in dbDevices" :key="dev.id">
                        <v-expansion-panel-header class="blue lighten-2">
                            <h4 class="white--text">{{ dev.name }}</h4>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-data-table hide-default-footer :headers="tblHeader" :items="dev.sparklines" mobile-breakpoint="0" multi-sort dense :items-per-page="-1">
                                <template v-slot:[`item.date`]="{ item }">
                                    <v-btn class="pa-0" color="primary" small text :to="{ name: 'playback', params: { device_id: dev.id, target_date: item.date } }">{{ item.date }}</v-btn>
                                </template>
                                <template v-slot:[`item.shot`]="{ item }">
                                    <v-progress-linear class="ma-2" height="15" :value="item['shot']" color="pink lighten-4">
                                        <h4>{{ item["shot"] }}</h4>
                                    </v-progress-linear>
                                </template>
                                <template v-slot:[`item.deer`]="{ item }">
                                    <v-progress-linear class="ma-2" height="15" :value="(item['deer'] / 10) * 100" color="amber lighten-2">
                                        <h4>{{ item["deer"] }}</h4>
                                    </v-progress-linear>
                                </template>
                                <template v-slot:[`item.boar`]="{ item }">
                                    <v-progress-linear class="ma-2" height="15" :value="(item['boar'] / 10) * 100" color="brown lighten-3">
                                        <h4>{{ item["boar"] }}</h4>
                                    </v-progress-linear>
                                </template>
                                <template v-slot:[`item.monkey`]="{ item }">
                                    <v-progress-linear class="ma-2" height="15" :value="(item['monkey'] / 10) * 100" color="lime darken-3">
                                        <h4>{{ item["monkey"] }}</h4>
                                    </v-progress-linear>
                                </template>
                                <template v-slot:[`item.bear`]="{ item }">
                                    <v-progress-linear class="ma-2" height="15" :value="(item['bear'] / 10) * 100" color="red lighten-1">
                                        <h4>{{ item["bear"] }}</h4>
                                    </v-progress-linear>
                                </template>
                            </v-data-table>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                -->
            </v-col>
        </v-row>
        <!-- ============================================= -->
    </v-container>
</template>

<style>
.v-expansion-panel-content__wrap {
    padding: 0 !important;
}
/*
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    padding: 0px 0px 0px 30px !important;
}
*/
</style>

<script>
import JWT from "jsonwebtoken";
export default {
    name: "Summary",
    //#######################################################
    data() {
        return {
            jwt: "",
            myInfo: [],
            dbDevices: [],
            dbShotLogs: [],
            //----------------------------------------------
            tblHeader: [
                { divider: true, cellClass: "pl-0", class: "blue darken-1 white--text", align: "center", width: "10%", text: "日付", value: "date" },
                { divider: true, cellClass: "pl-0", class: "blue darken-1 white--text", align: "center", width: "10%", text: "撮影枚数", value: "shot" },
                { divider: true, cellClass: "pl-0", class: "blue darken-1 white--text", align: "center", width: "10%", text: "シカ", value: "deer" },
                { divider: true, cellClass: "pl-0", class: "blue darken-1 white--text", align: "center", width: "10%", text: "イノシシ", value: "boar" },
                { divider: true, cellClass: "pl-0", class: "blue darken-1 white--text", align: "center", width: "10%", text: "ウリ坊", value: "boarlet" },
                { divider: true, cellClass: "pl-0", class: "blue darken-1 white--text", align: "center", width: "10%", text: "サル", value: "monkey" },
                { divider: true, cellClass: "pl-0", class: "blue darken-1 white--text", align: "center", width: "10%", text: "クマ", value: "bear" },
            ],
            //----------------------------------------------
            targetMonth: this.$moment().format("YYYY-MM"),
            maxMonth: this.$moment().format("YYYY-MM"),
            menuMonth: false,
            modal: false,
            //----------------------------------------------
            isLoading: false,
        };
    },
    //#######################################################
    components: {},
    //#######################################################
    created: async function () {
        this.jwt = this.$localStorage.get("user-jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return true;
        }
        this.myInfo = JWT.decode(this.jwt);
        if (this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return true;
        }
        //---------------------------------
        this.isLoading = true;
        //---------------------------------
        const promiseDevices = this.axiosGetDevices();
        const promiseShotLogs = this.axiosGetShotLogs();
        await promiseDevices;
        await promiseShotLogs;
        this.createSparkLineData();

        await new Promise((r) => setTimeout(r, 1000));
        this.isLoading = false;
        window.scrollTo(0, 0);
    },
    //#######################################################
    mounted: function () {},
    //#######################################################
    methods: {
        //====================================================
        async axiosGetDevices() {
            await this.axios({
                method: "GET",
                url: "/web/api/devices",
                params: { "_order[sort_no]": "asc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 10000,
            }).then((response) => {
                this.dbDevices = response.data.json;
            });
        },
        //====================================================
        async axiosGetShotLogs() {
            //----------------------------------
            const month = this.targetMonth + "-01";
            let sdate = this.$moment(month).add(0, "month").format("YYYY-MM-DD");
            let edate = this.$moment(month).add(1, "month").format("YYYY-MM-DD");
            //----------------------------------
            await this.axios({
                method: "GET",
                url: "/web/api/shot_logs",
                params: {
                    "received_at[EQGREAT]": sdate,
                    "received_at[SMALL]": edate,
                    "_order[received_at]": "asc",
                },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 10000,
            }).then((response) => {
                this.dbShotLogs = response.data.json;
            });
        },
        //====================================================
        createSparkLineData() {
            //-------------------------------------------
            // 一次集計（カウントアップしやすく、取り出しやすい様、Object型で）
            let shotCount = {};
            for (let shot of this.dbShotLogs) {
                const device_id = shot["device_id"];
                const received_at = shot["received_at"];
                const strJson = shot["ai_analyzed"];
                const received = this.$moment(received_at).format("YYYY-MM-DD");
                //------------------------------------------
                if (!shotCount[device_id]) shotCount[device_id] = {};
                if (!shotCount[device_id][received]) shotCount[device_id][received] = {};
                if (!shotCount[device_id][received]["shot"]) shotCount[device_id][received]["shot"] = 0;
                if (!shotCount[device_id][received]["deer"]) shotCount[device_id][received]["deer"] = 0;
                if (!shotCount[device_id][received]["boar"]) shotCount[device_id][received]["boar"] = 0;
                if (!shotCount[device_id][received]["boarlet"]) shotCount[device_id][received]["boarlet"] = 0;
                if (!shotCount[device_id][received]["bear"]) shotCount[device_id][received]["bear"] = 0;
                if (!shotCount[device_id][received]["monkey"]) shotCount[device_id][received]["monkey"] = 0;
                shotCount[device_id][received]["shot"] += 1;
                //------------------------------------------
                if (strJson == null) continue;
                if (strJson == "[]") continue;
                const json = JSON.parse(strJson);
                //------------------------------------------
                for (const detect of json) {
                    const animal = detect["class"];
                    if (animal == "deer") shotCount[device_id][received]["deer"] += 1;
                    if (animal == "boar") shotCount[device_id][received]["boar"] += 1;
                    if (animal == "boarlet") shotCount[device_id][received]["boarlet"] += 1;
                    if (animal == "bear") shotCount[device_id][received]["bear"] += 1;
                    if (animal == "monkey") shotCount[device_id][received]["monkey"] += 1;
                }
            }
            //----------------------------------
            // 1ヶ月分の表示用配列を作成
            const month = this.targetMonth + "-01";
            const sdate = this.$moment(month).add(0, "month").format("YYYY-MM-DD");
            const edate = this.$moment(month).add(1, "month").format("YYYY-MM-DD");
            const sparklines = [];
            const now = this.$moment().format("YYYY-MM-DD");
            for (let i = 1; i <= 31; i++) {
                const dt = this.$moment(edate)
                    .add(i * -1, "days")
                    .format("YYYY-MM-DD");
                if (dt > now) continue;
                if (dt < sdate) break;
                sparklines.push({ date: dt, shot: 0, boar: 0, boarlet: 0, deer: 0, monkey: 0, bear: 0 });
            }
            // 各デバイスにコピー
            for (let idx in this.dbDevices) {
                this.dbDevices[idx]["sparklines"] = JSON.parse(JSON.stringify(sparklines));
            }
            //-------------------------------------------
            // 一次集計を基に、表示用配列にコピー
            // self.console.log(shotCount);
            for (const dev of this.dbDevices) {
                const device_id = dev["id"];
                for (const spk of dev["sparklines"]) {
                    const received = spk["date"];
                    spk["shot"] = shotCount[device_id] && shotCount[device_id][received] ? shotCount[device_id][received]["shot"] : 0;
                    spk["deer"] = shotCount[device_id] && shotCount[device_id][received] ? shotCount[device_id][received]["deer"] : 0;
                    spk["boar"] = shotCount[device_id] && shotCount[device_id][received] ? shotCount[device_id][received]["boar"] : 0;
                    spk["boarlet"] = shotCount[device_id] && shotCount[device_id][received] ? shotCount[device_id][received]["boarlet"] : 0;
                    spk["bear"] = shotCount[device_id] && shotCount[device_id][received] ? shotCount[device_id][received]["bear"] : 0;
                    spk["mony"] = shotCount[device_id] && shotCount[device_id][received] ? shotCount[device_id][received]["monkey"] : 0;
                }
            }
            //-------------------------------------------
        },
        //====================================================
        async changeMonth() {
            this.menuMonth = false;
            this.isLoading = true;
            await new Promise((r) => setTimeout(r, 1000));
            await this.axiosGetShotLogs();
            this.createSparkLineData();
            this.isLoading = false;
        },
        //====================================================
    },
    //#######################################################
};
</script>
